module.exports = __webpack_public_path__ + "img/img-cd8dd947.7ece2085.png";